import { render, staticRenderFns } from "./DocumentsBatchRetrieve.vue?vue&type=template&id=589cfbf9"
import script from "./DocumentsBatchRetrieve.vue?vue&type=script&lang=js"
export * from "./DocumentsBatchRetrieve.vue?vue&type=script&lang=js"
import style0 from "./DocumentsBatchRetrieve.vue?vue&type=style&index=0&id=589cfbf9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports